<template>
  <div class="flex items-center mt-2 ml-2">
    <label
      :for="id"
      class="inline-flex relative items-center cursor-pointer"
      :title="label"
    >
      <input
        :id="id"
        v-model="model"
        type="checkbox"
        class="sr-only peer"
        :name="name"
        :disabled="buttonsDisabled"
      />
      <div
        class="toggle-selector w-11 h-6 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:border after:rounded-full after:h-5 after:w-5 after:transition-all"
        :class="buttonsDisabled ? 'button-disabled' : null"
      ></div>
    </label>
  </div>
</template>

<script setup lang="ts">
import { useId } from "vue";

const id = useId();

const model = defineModel<boolean>();

withDefaults(
  defineProps<{
    name: string;
    label: string;
    buttonsDisabled?: boolean;
  }>(),
  { buttonsDisabled: false }
);
</script>

<style lang="scss" scoped>
@use "@/assets/styles/reader.scss" as *;

.toggle-selector {
  border: 3px solid var(--DM__theme-hover-color);
  background-color: var(--DM__theme-slider-color);
  transition: all 0.1s ease;

  @media (any-hover: hover) {
    &:hover {
      border-color: var(--DM__theme-slider-color);
      background-color: var(--DM__theme-hover-color);
    }
  }
}
.peer {
  background-color: var(--DM__color-grisFonce);
  &::after {
    background-color: var(--DM__color-light);
  }
  &:checked ~ .peer {
    background-color: var(--DM__color-greenBase);
    &::after {
      border: 1px solid var(--DM__theme-slider-color);
    }
  }
  &:checked ~ .peer.button-disabled {
    opacity: 0.7;
    border-color: var(--DM__color-grisFonce);
    background-color: var(--DM__color-grisFonce);
    cursor: not-allowed;
    @media (any-hover: hover) {
      &:hover {
        border-color: var(--DM__color-grisFonce);
        background-color: var(--DM__color-grisFonce);
      }
    }
  }
  &:focus {
    ~ .peer {
      border-color: var(--DM__theme-border-color);
      outline: 0;
      &:not(:focus-visible) {
        border-color: var(--DM__theme-slider-color);
      }
    }
  }
}
</style>
